import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { secretCodeAES } from "./app-constants";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { store } from "../hooks/redux/store";

export const toastEmitter = (type = "info", message = "") => {
  switch (type) {
    case "success":
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
      });
      break;
    case "warn":
      toast.warn(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
      });
      break;
    case "error":
      toast.error(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
      });
      break;
    case "info":
      toast.info(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
      });
      break;
    default:
      toast(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
      });
      break;
  }
};

export const encryptJSONtoAES = (str) => {
  if (!str) return false;
  return CryptoJS.AES.encrypt(str, secretCodeAES).toString();
};

export const decryptAEStoJSON = (str) => {
  if (!str) return false;
  const bytes = CryptoJS.AES.decrypt(str, secretCodeAES);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const encryptStringtoAES = (str) => {
  if (!str) return false;
  return CryptoJS.AES.encrypt(str.toString(), secretCodeAES).toString();
};

export const decryptAEStoString = (str) => {
  if (!str) return false;
  const bytes = CryptoJS.AES.decrypt(str, secretCodeAES);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const getCurrentUser = () => {
  let state = store.getState(),
    loggedUser = state.loggedUser.value;
  loggedUser = loggedUser ? decryptAEStoJSON(loggedUser) : false;
  return loggedUser;
};

export const modifyTableDate = (str) => {
  if (!str) return false;
  return new Date(str).toLocaleString();
};

export const checkValidation = (
  value,
  fieldName,
  errorMessage,
  regex,
  formError,
  setFormError
) => {
  const updatedError = { ...formError };

  let statusName = `${fieldName}Status`;
  if (value === "") {
    updatedError[fieldName] = "";
    updatedError[statusName] = false;
  } else if (!value.match(regex)) {
    updatedError[fieldName] = errorMessage;
    updatedError[statusName] = true;
  } else {
    updatedError[fieldName] = "";
    updatedError[statusName] = false;
  }
  setFormError(updatedError);
};

// Masking function
export const maskNumber = (value) => {
  if (value?.length === 12) {
    // for adhar
    const visibleDigits = value?.slice(-4);
    const maskedDigits = value?.slice(0, -4)?.replace(/\d/g, "*");
    return maskedDigits + visibleDigits;
  } else {
    // for mobile
    const visibleDigits = value?.slice(-3);
    const maskedDigits = value?.slice(0, -3)?.replace(/\d/g, "*");
    return maskedDigits + visibleDigits;
  }
};
export const maskPAN = (panNumber) => {
  const visibleChars = panNumber?.slice(-2);
  const maskedChars = panNumber
    ?.slice(0, 2)
    ?.padEnd(panNumber?.length - 2, "*");
  return maskedChars + visibleChars;
};

export const downloadFile = (filetype, response, filename) => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement("a");
  link.href = url;
  // link.setAttribute('download', `${filename}-${new Date().getTime()}.${filetype}`);
  link.setAttribute("download", `${filename}.${filetype}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadAgreement = async (url = "", fileName = "") => {
  var currentdate = new Date();
  var datetime =
    +currentdate.getDate() +
    "/" +
    (currentdate.getMonth() + 1) +
    "/" +
    currentdate.getFullYear() +
    " @ " +
    currentdate.getHours() +
    ":" +
    currentdate.getMinutes() +
    ":" +
    currentdate.getSeconds();
  try {
    const response = await fetch(url, {
      method: "GET",
    });
    if (!response.ok) throw new Error("Failed to fetch the file.");
    // Convert response to Blob
    const blob = await response.blob();
    // Convert Blob to ArrayBuffer then Uint8Array (byte array)
    const arrayBuffer = await blob.arrayBuffer();
    const byteArray = new Uint8Array(arrayBuffer);
    // Create a new Blob from byte array
    const byteBlob = new Blob([byteArray], { type: "application/pdf" });
    // Create object URL for download
    const downloadUrl = window.URL.createObjectURL(byteBlob);
    // Create and trigger the download link
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `${fileName}_${datetime}.pdf`;
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed:", error.message);
  }
}

export const downloadPdfFile = async (apiurl, filename, filetype, data, setBtnLodaer) => {
  let temToken = localStorage.getItem("temToken")
  let state = store.getState();
  let rawAccessToken = state?.adminAccessToken?.value;
  rawAccessToken = rawAccessToken
    ? decryptAEStoString(rawAccessToken)
    : rawAccessToken;
  var currentdate = new Date();
  var datetime =
    +currentdate.getDate() +
    "/" +
    (currentdate.getMonth() + 1) +
    "/" +
    currentdate.getFullYear() +
    " @ " +
    currentdate.getHours() +
    ":" +
    currentdate.getMinutes() +
    ":" +
    currentdate.getSeconds();
  try {
    function blobToBase64(blob, callback) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        setBtnLodaer && setBtnLodaer(false);
        callback(reader.result);
      };

    }

    fetch(`${apiurl}`, {
      method: "POST",
      body: JSON.stringify(data || ""),
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${rawAccessToken || temToken}`
      },
    })
      .then(response => response.blob())
      .then(blob => {
        blobToBase64(blob, (base64Data) => {
          const link = document.createElement("a");
          link.href = base64Data;
          link.setAttribute("download", `${filename}_${datetime}${filetype || `.pdf`}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setBtnLodaer && setBtnLodaer(false);
        });
      })
      .catch(err => {
        console.log("Error downloading PDF:", err);
        setBtnLodaer && setBtnLodaer(false);
      });
  } catch (error) {
    setBtnLodaer(false)
    console.log(error.message);
  }
};

export const openPdfFile = (url, fileName) => {
  window.open(url);
};

export const docName = (docUrl = "") => {
  let file =
    docUrl &&
    docUrl.length > 10 &&
    docUrl?.substring(docUrl?.lastIndexOf("/") + 1);
  if (file?.length > 20) {
    return file?.substring(0, 20) + "...";
  } else {
    return file;
  }
};


export const ShowdocName = (docUrl = "") => {
  let file =
    docUrl &&
    docUrl.length > 10 &&
    docUrl?.substring(docUrl?.lastIndexOf("/") + 1);
  if (file?.length > 20) {
    return file?.substring(0, 20) + "...";
  } else {
    return file;
  }
};

export const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const timeFormate = (timeString) => {
  let timeComponents = timeString?.split(":");
  let hours = parseInt(timeComponents[0]);
  let minutes = parseInt(timeComponents[1]);
  let seconds = parseInt(timeComponents[2]);
  let getAmPM = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return (
    hours +
    ":" +
    ("0" + minutes)?.slice(-2) +
    ":" +
    ("0" + seconds)?.slice(-2) +
    " " +
    getAmPM
  );
};

export const convertDateToDDMMYYYY = (dateString) => {
  if (!dateString) {
    return new Date()?.toLocaleDateString()
  }
  const [datePart] = dateString?.split(' ');
  const [year, month, day] = datePart?.split('-');
  return `${day?.padStart(2, '0')}-${month?.padStart(2, '0')}-${year}`;

}


export const removeDuplicateKM = (input) => {
  if (input) {
    return input?.replace(/(KM)(.*)/, (match, p1, p2) => p1 + p2?.replace(/KM/g, ''));
  }
  return input;
};

export const extractDate = (datetimeStr) => {
  const date = new Date(datetimeStr?.replace(" ", "T"));
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1)?.padStart(2, '0');
  const day = String(date?.getDate())?.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const dateTimeFormate = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const day = String(date?.getUTCDate()).padStart(2, "0");
  const month = String(date?.getUTCMonth() + 1).padStart(2, "0");
  const year = date?.getUTCFullYear();
  const hours = date?.getUTCHours();
  const minutes = String(date?.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date?.getUTCSeconds()).padStart(2, "0");
  const amPM = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  return `${day}-${month}-${year}, ${formattedHours}:${minutes}:${seconds} ${amPM}`;
};

export const validateIPaddress = (ipaddress, type) => {
  if (type === 0) {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        ipaddress
      )
    )
      return true;
  } else {
    if (
      /^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$/gm.test(
        ipaddress
      )
    )
      return true;
  }
  return false;
};

export const distanceformatValue = (a, x) => { return `${a} ${x}`; }


